import React, { useState } from 'react';
import { useData } from '../contexts/DataContext';
import { FaPlus, FaTrash, FaEdit, FaSave, FaTimes } from 'react-icons/fa';

const Products = () => {
    const { products, addProduct, updateProduct, deleteProduct, resetProducts } = useData();
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({ category: '', name: '', priceClassique: '', priceParis: '' });

    const categories = [...new Set(products.map(p => p.category))];

    const handleSubmit = (e) => {
        e.preventDefault();
        const price = parseFloat(formData.priceClassique) || 0;
        const data = {
            ...formData,
            priceClassique: price,
            priceParis: price
        };

        if (editingId) {
            updateProduct(editingId, data);
            setEditingId(null);
        } else {
            addProduct(data);
        }

        setFormData({ category: '', name: '', priceClassique: '', priceParis: '' });
        setShowForm(false);
    };

    const startEdit = (product) => {
        setEditingId(product.id);
        setFormData({
            category: product.category,
            name: product.name,
            priceClassique: product.priceClassique,
            priceParis: product.priceParis
        });
        setShowForm(true);
    };

    const cancelEdit = () => {
        setEditingId(null);
        setFormData({ category: '', name: '', priceClassique: '', priceParis: '' });
        setShowForm(false);
    };

    return (
        <div className="page-container p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Gestion des Produits et Tarifs</h2>
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => resetProducts()}
                    >
                        Restaurer le catalogue
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            if (showForm && editingId) cancelEdit();
                            else setShowForm(!showForm);
                        }}
                    >
                        {showForm ? <><FaTimes className="me-2" /> Fermer</> : <><FaPlus className="me-2" /> Nouveau Produit</>}
                    </button>
                </div>
            </div>

            {showForm && (
                <div className="card mb-4 shadow-sm">
                    <div className="card-header bg-light">
                        <h5 className="mb-0">{editingId ? 'Modifier le produit' : 'Ajouter un nouveau produit'}</h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Catégorie</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        list="categories"
                                        required
                                        value={formData.category}
                                        onChange={e => setFormData({ ...formData, category: e.target.value.toUpperCase() })}
                                        placeholder="Ex: DIVERS, STELLITE..."
                                    />
                                    <datalist id="categories">
                                        {categories.map(c => <option key={c} value={c} />)}
                                    </datalist>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Nom de la prestation</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        value={formData.name}
                                        onChange={e => setFormData({ ...formData, name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Tarif Finition Nova (€)</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        required
                                        value={formData.priceClassique}
                                        onChange={e => setFormData({ ...formData, priceClassique: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="d-flex gap-2">
                                <button type="submit" className="btn btn-success">
                                    <FaSave className="me-2" /> {editingId ? 'Mettre à jour' : 'Enregistrer'}
                                </button>
                                {editingId && (
                                    <button type="button" className="btn btn-outline-secondary" onClick={cancelEdit}>
                                        Annuler
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {categories.map(category => (
                <div key={category} className="mb-5">
                    <h4 className="border-bottom pb-2 mb-3 text-primary">{category}</h4>
                    <div className="table-responsive shadow-sm rounded">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-dark">
                                <tr>
                                    <th style={{ width: '50%' }}>Prestation</th>
                                    <th className="text-center">Tarif Finition Nova</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.filter(p => p.category === category).map(product => (
                                    <tr key={product.id}>
                                        <td>{product.name}</td>
                                        <td className="text-center fw-bold text-success">{product.priceClassique.toFixed(2)} €</td>
                                        <td className="text-end">
                                            <div className="d-flex justify-content-end gap-2">
                                                <button className="btn btn-sm btn-outline-info" onClick={() => startEdit(product)}>
                                                    <FaEdit />
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => deleteProduct(product.id)}>
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}

            {products.length === 0 && (
                <div className="text-center my-5 p-5 bg-light rounded border">
                    <p className="text-muted mb-0">Aucun produit configuré. Cliquez sur "Nouveau Produit" pour commencer.</p>
                </div>
            )}
        </div>
    );
};

export default Products;
